

































































































































































































































































































































import Vue, { PropType } from 'vue';
import moment from 'moment';
import {
  IInventoryAdvancePayment,
  InventoryAdvancePaymentPaymentType
} from '@/models';
import { DataTableHeader } from 'vuetify';

export default Vue.extend({
  name: 'InventoryAdvancePaymentDetail',

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>,
      required: true
    }
  },

  data: () => ({
    headers: [
      {
        text: '#',
        value: 'index',
        width: 45,
        sortable: false,
        class: 'primary white--text subtitle-1'
      },
      {
        text: 'Item',
        value: 'item',
        width: 300,
        sortable: false,
        class: 'primary white--text subtitle-1'
      },

      {
        text: 'Account',
        value: 'account',
        width: 100,
        sortable: false,
        class: 'primary white--text subtitle-1'
      },
      {
        text: 'Department',
        value: 'department',
        sortable: false,
        width: 100,
        class: 'primary white--text subtitle-1'
      },
      {
        text: 'Amount',
        value: 'total_price',
        align: 'center',
        width: 100,
        sortable: false,
        class: 'primary white--text subtitle-1'
      }
    ] as DataTableHeader[]
  }),

  methods: {
    momentFormat(date: Date | string | number, days = 0) {
      return moment(date ?? new Date())
        .add(days, 'd')
        .format('LL')
        .toString();
    },

    genPaymentType(payment: number): string {
      switch (payment) {
        case InventoryAdvancePaymentPaymentType.CASH:
          return 'Cash';
        case InventoryAdvancePaymentPaymentType.CARD:
          return 'Card';
        case InventoryAdvancePaymentPaymentType.CHEQUE:
          return 'Cheque';
        case InventoryAdvancePaymentPaymentType.WIRE:
          return 'Wire';
        default:
          return '-'; //default display value
      }
    }
  }
});
